"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 3/7/2017.
 */
var Periodicity;
(function (Periodicity) {
    Periodicity[Periodicity["ONCE"] = 0] = "ONCE";
    Periodicity[Periodicity["YEARLY"] = 1] = "YEARLY";
    Periodicity[Periodicity["SEMIANNUAL"] = 2] = "SEMIANNUAL";
    Periodicity[Periodicity["QUARTERLY"] = 3] = "QUARTERLY";
    Periodicity[Periodicity["MONTHLY"] = 4] = "MONTHLY";
    Periodicity[Periodicity["DAILY"] = 5] = "DAILY";
})(Periodicity = exports.Periodicity || (exports.Periodicity = {}));
//# sourceMappingURL=periodicity.enum.js.map